import React from "react";
import Page404 from "../../../Components/Page404";
import PubHubSite from "../PubHubSite/index"
import "./_index.scss";
import { exception_404 } from "../../../utility/url";

export default class extends React.Component {
    state = {
        error: false,
    }

    componentDidUpdate() {
        if (this.state.error) {
            exception_404();
        }
    }

    render() {
        const {uri, phlocation, setting} = this.props.route;
        let {projectName, pageName} = this.props.params;

        // if this is a pubhub page
        if (uri) {
            projectName = uri;
        }

            // for preview on stage
        // if (phlocation) {
        //     return <PubHubSite projectName={projectName} pageName={pageName}
        //                         setting={setting} route={this.props.route} setReady={this.props.setReady} />;
        // }

        return this.state.error ? (
            <Page404 />
        ) : (
            <PubHubSite
                projectName={projectName}
                pageName={pageName}
                phlocation={phlocation}
                setting={setting}
                route={this.props.route}
                setReady={this.props.setReady}
                setError={() => this.setState({ error: true })}
            />
        );
    }
}
